const container = document.getElementById('related-blog-posts')
const stringTags = container.getAttribute('data-blog-tags')
const tagsArray = stringTags.split(',')

function getBlogs() {
  let str = ''

  tagsArray.forEach((item) => {
    if (item !== '') {
      if (str === '') {
        str = item.toLowerCase().replaceAll(' ', '-')
      } else {
        str += ' OR ' + item.toLowerCase().replaceAll(' ', '-')
      }
    }
  })

  if (tagsArray.length !== 0) {
    fetch(`/search/suggest?q=${str}&resources[type]=article&resources[limit]=4&section_id=blog-related-posts-search`).then(res => {
        if (!res.ok) {
          throw new Error()
        }

        return res.text()
      }
    ).then(data => {
      container.innerHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('#shopify-section-blog-related-posts-search').innerHTML
    })
  }
}

getBlogs()
